<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Sms Settings</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="8">
            <v-row>

              <v-col cols="12" xs="12" sm="12" md="12"> 
                 <span class="style-16" v-if="record.smsEnabled == 'Y'">Sms Enabled: Yes</span>
                 <span class="style-16" v-if="record.smsEnabled == 'N'">Sms Enabled: No</span>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6">
                <v-text-field
                  label="Sender Id"
                  v-model="record.senderId"
                  readonly
                  filled
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6">
                <v-text-field
                  label="Client Id"
                  v-model="record.clientId"
                  readonly
                  filled
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12">
                <v-text-field
                  label="Api Key"
                  v-model="record.apiKey"
                  readonly
                  filled
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="6">
                <v-text-field
                  label="Country Code"
                  v-model="record.countryCode"
                  readonly
                  filled
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="6">
                <v-text-field
                  label="Admin Phone"
                  v-model="record.adminPhone"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12">
                <v-textarea
                  rows="3"
                  label="Message Signature"
                  v-model="record.messageSignature"
                  outlined
                  dense
                ></v-textarea>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="6">
                <v-btn class="accent" @click="save" :loading="loader"
                  >Update</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      record: {},
      loader: false,
    };
  },
  methods: {
    save() {
      const data = this.record;
      const self = this;
      self.loader = true;
      const url = "/sms-settings/update";
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.getGenSettings();
            this.$refs.snackbar.show("Update Successful", "green");
          } else {
            // this.$refs.snackbar.show(res.ResultDesc, "red");
            self.loader = false;
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      var subscriberId = localStorage.getItem("subscriber_id");
     //  this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/sms-settings/${subscriberId}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.record = res.ResponseData;
           //  self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getGenSettings();
  },
};
</script>

<style lang="scss" scoped>
</style>